<template>
    <div class="w-full flex flex-col sm:flex-row sm:justify-between sm:items-center my-lg p-lg bg-white shadow rounded-xl">
        <div>
            Med markerade ({{ selectedAddresses.length }} st):
        </div>
        <div class="flex">
            <move-selected-addresses
                :project="project"
                :projects="projects"
                :selected-addresses="signedAddresses"
                route-name="api.sales-projects.move-selected-addresses.store"
                class="sm:mr-md"
                modal-information="Detta kommer att flytta de adresser som är valda och osignerade till det valda projektet. Adresserna kommer att tas bort ur aktiv säljomgång samt att tilldelat team och säljare kopplas bort."
            />
            <add-addresses-to-group
                class="sm:mr-md"
                :project="project"
                :groups="groups"
                :selected-addresses="selectedAddresses"
            />
            <create-group-with-addresses
                :project="project"
                :types="types"
                :selected-addresses="selectedAddresses"
            />
        </div>
    </div>
</template>

<script>
    import AddAddressesToGroup from '../Projects/Groups/AddAddressesToGroup';
    import CreateGroupWithAddresses from '../Projects/Groups/CreateGroupWithAddresses';

    export default {
        components: { AddAddressesToGroup, CreateGroupWithAddresses },
        props: {
            selectedAddresses: {
                required: true,
                type: Array,
            },
            project: {
                required: true,
                type: Object,
            },
            projects: {
                type: Object,
                required: true,
            },
            types: {
                required: true,
                type: Object, // array with named keys = Object
            },
            groups: {
                required: true,
                type: Array,
            },
        },
        computed: {
            signedAddresses() {
                if (Object.keys(this.selectedAddresses).length === 0) {
                    return this.selectedAddresses;
                }

                return this.selectedAddresses.filter((address) => ! address.is_signed);
            },
        },
    };
</script>
